import { createUseStyles } from 'react-jss'
import { defaultBorderRadius } from '../../../../styles/const/common'
import { lightGrey } from '../../../../styles/const/colors'

const useStyles = createUseStyles({
  checkBoxBlockContainer: {
    padding: ({ withBorder }) => withBorder && '14px 19px',
    border: ({ withBorder }) => withBorder && `1px solid ${lightGrey}`,
    borderRadius: defaultBorderRadius,
    backgroundColor: ({ withBorder }) => withBorder && 'white',
    marginTop: 16,
    '& .checkbox': {
      margin: '0 !important'
    }
  },
  checkBoxBlockBody: {
    paddingBottom: 5
  }
})

export default useStyles
